import React, { useState, useEffect } from 'react';
import { Formik } from 'formik';
import FloatingTextInput from '../../../components/FloatingInput';
import SubmitButton from '../../../components/SubmitButton';
import registrationSchema from './registrationSchema';
import {
  callStreamInfo,
  callJoinStreamV2,
  callJoinStream,
  callJoinStreamWithAttendeeId,
  callAttendeeToken,
  callAddContact,
  callEvent,
} from '../../../services/main.service';
import useAppDispatch from '../../../hooks/useAppDispatch';
import {
  setInfoData,
  setJoinData,
  setJoinAttendeeIDData,
  setAttendeeToken,
  setStramState,
} from '../../live-main/livemain.actions';
import useAppNavigation from '../../../hooks/useAppNavigation';
import { setUserData, setLanguage } from '../Login/login.actions';
import Loader from '../../../components/loader';
import useAppAccessor from '../../../hooks/useappAccessor';
import {
  getBrandColor,
  REGISTRATION_PARTNER_CO_COLOR,
} from '../../../utils/brand.util';

const RegistrationForm = (props: any) => {
  const dispatch = useAppDispatch();
  const { getUserData, getLiveMainData } = useAppAccessor();
  const { infoData } = getLiveMainData();
  const { language, client, referrer_user } = getUserData();

  const registrationBrandColor =
    client === 'partner.co' ? REGISTRATION_PARTNER_CO_COLOR : getBrandColor(client);
  const { navigate } = useAppNavigation();
  const [isShowLoader, setIsShowLoader] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState('1');
  let timer: any;

  const dummyData = {
    firstName: 'John',
    lastName: 'Doe',
    email: `john.doe.${Date.now()}@example.com`,
  };

  const formikRef = React.useRef<any>(null);

  const handleLanguageChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const languageCode = e.target.value;
    setSelectedLanguage(languageCode);

    fetch(`${window.location.origin}/lang/${languageCode}.json`)
      .then((response) => response.json())
      .then((data) => {
        dispatch(setLanguage(data));
      })
      .catch((error) => {
        console.error('Error loading language file:', error);
      });
  };

  useEffect(() => {
    if (language['join_button'] == 'Join') {
      setSelectedLanguage('en');
    } else if (language['join_button'] == '加入') {
      setSelectedLanguage('zh_CN');
    } else if (language['join_button'] == 'Bergabung') {
      setSelectedLanguage('id');
    } else if (language['join_button'] == 'Sertai') {
      setSelectedLanguage('ms_MY');
    }
  }, [language]);

  useEffect(() => {
    if (props.autoFill && props.hostData && formikRef.current) {
      const timer = setTimeout(() => {
        formikRef.current?.submitForm();
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [props.autoFill, props.hostData]);

  const tryToJoin = (
    email: string,
    family_name: string,
    given_name: string
  ) => {
    callStreamInfo(props.roomId).then((info: any) => {
      dispatch(setInfoData(info));
      callJoinStreamV2(props.roomId, {
        streamInstanceId: info['streamInstanceId'],
        hostModel: info['hostModel'],
        attendee: {
          email: email,
          family_name: family_name,
          given_name: given_name,
        },
        sendRemoteMessage: true,
        waitingRoomEnabled: true,
      })
        .then((resp: any) => {
          dispatch(setJoinData(resp));
          dispatch(
            setUserData({
              publicUserData: {
                email: email,
                family_name: family_name,
                given_name: given_name,
              },
            })
          );

          callJoinStreamWithAttendeeId(props.roomId, resp['attendee_id']).then(
            (response: any) => {
              dispatch(setJoinAttendeeIDData(response));

              var payload = {
                referred_by_livestream_instance_id: info['streamInstanceId'],
                third_party_id: resp['attendee_id'],
                live_attendee_id: resp['attendee_id'],
                email: email,
                last_name: family_name,
                first_name: given_name,
                source: 'live',
                folder: 'live',
                host_name: props.hostData.host_full_name,
                host_uuid: props.hostData.host_id,
              };

              var re = response.issuer_metadata;

              const url = re?.webhook_domain
                ? `${re?.webhook_domain}/remote/contacts/add.json`
                : re?.webhook_endpoint_join;

              try {
                callAddContact(payload, url, `Bearer ${re?.webhook_token}`);
              } catch (error) {
                // console.log(error);
              }

              callAttendeeToken(props.roomId, {
                stream_instance_id: resp['stream_instance_id'],
                stream_vendor_user_id: resp['stream_vendor_user_id'],
              }).then((tokenResponse: any) => {
                dispatch(setAttendeeToken(tokenResponse));
                dispatch(setStramState('started'));
                props.attendeeJoinedCallback();
                if (timer != null) {
                  clearInterval(timer);
                }
              });
            }
          );
        })
        .catch((err) => {
          if (
            err?.response?.data?.error?.indexOf('is not ready to join') > -1 ||
            err?.response?.data?.error?.indexOf(
              'Maximum attendees reached for this stream'
            ) > -1
          ) {
            props.setWaittingCallback(true);
            setTimeout(() => tryToJoin(email, family_name, given_name), 5000);
          }
        });
    });
    // callJoinStream(props.roomId, {
    //   attendee: {
    //     email: email,
    //     family_name: family_name,
    //     given_name: given_name,
    //   },
    //   sendRemoteMessage: true,
    //   waitingRoomEnabled: true,
    // })
    //   .then((resp: any) => {
    //     dispatch(setJoinData(resp));
    //     dispatch(
    //       setUserData({
    //         publicUserData: {
    //           email: email,
    //           family_name: family_name,
    //           given_name: given_name,
    //         },
    //       })
    //     );
    //     callJoinStreamWithAttendeeId(props.roomId, resp["attendee_id"]).then(
    //       (response: any) => {
    //         dispatch(setJoinAttendeeIDData(response));
    //         callAttendeeToken(props.roomId, {
    //           stream_instance_id: resp["stream_instance_id"],
    //           stream_vendor_user_id: resp["stream_vendor_user_id"],
    //         }).then((tokenResponse: any) => {
    //           dispatch(setAttendeeToken(tokenResponse));
    //           dispatch(setStramState("started"));
    //           props.attendeeJoinedCallback();
    //         });
    //       }
    //     );
    //   })
    //   .catch((err) => {
    //     if (err?.response?.data?.error?.indexOf("is not ready to join") > -1 || err?.response?.data?.error?.indexOf("Maximum attendees reached for this stream") > -1) {
    //       props.setWaittingCallback(true);
    //       setTimeout(() => tryToJoin(email, family_name, given_name), 5000);
    //     }
    //   });
  };


  return (
    <>
      <Formik
        innerRef={formikRef}
        initialValues={{
          firstName: props.autoFill ? dummyData.firstName : '',
          lastName: props.autoFill ? dummyData.lastName : '',
          email: props.autoFill ? dummyData.email : '',
        }}
        enableReinitialize={true}
        onSubmit={(values) => {
          setIsShowLoader(true);
          callStreamInfo(props.roomId).then((info: any) => {
            dispatch(setInfoData(info));
            callJoinStreamV2(props.roomId, {
              streamInstanceId: info['streamInstanceId'],
              hostModel: info['hostModel'],
              attendee: {
                email: values.email,
                family_name: values.lastName,
                given_name: values.firstName,
              },
              sendRemoteMessage: true,
              waitingRoomEnabled: true,
            })
              .then((resp: any) => {
                dispatch(setJoinData(resp));
                callEvent([
                  {
                    event_data: {
                      attendee_email: values.email,
                      attendee_first: values.firstName,
                      attendee_last: values.lastName,
                      date: new Date().toUTCString(),
                    },
                    event_type: 'guest_sign_in',
                    group_parameters: {},
                  },
                ]);
                dispatch(
                  setUserData({
                    publicUserData: {
                      email: values.email,
                      family_name: values.lastName,
                      given_name: values.firstName,
                    },
                  })
                );
                callJoinStreamWithAttendeeId(props.roomId, resp['attendee_id'])
                  .then((response: any) => {
                    dispatch(setJoinAttendeeIDData(response));
                    try {
                      if (referrer_user) {
                        callEvent([
                          {
                            event_data: {
                              attendee_email: values.email,
                              attendee_first: values.firstName,
                              attendee_last: values.lastName,
                              issuer_referrer_id:
                                referrer_user.webhook_referrer_id,
                              issuer_referrer_name:
                                referrer_user.webhook_referrer_name,
                              date: new Date().toUTCString(),
                            },
                            event_type: 'guest_sign_in',
                            group_parameters: {},
                          },
                        ]);

                        callEvent([
                          {
                            event_data: {
                              attendee_email: values.email,
                              attendee_first: values.firstName,
                              attendee_id: resp['attendee_id'],
                              attendee_role: resp['role'],
                              attendee_last: values.lastName,
                              client_id: infoData['hostModel']['clientId'],
                              stream_id: props.roomId,
                              stream_instance_id: resp['stream_instance_id'],
                              user_id: infoData['hostModel']['userId'],
                              max_presenters: 3,
                              elapsed_seconds: '0',
                              issuer_referrer_id:
                                referrer_user.webhook_referrer_id,
                              issuer_referrer_name:
                                referrer_user.webhook_referrer_name,
                              date: new Date().toUTCString(),
                            },
                            event_type: 'attendee_joined',
                          },
                        ]);
                      } else {
                        callEvent([
                          {
                            event_data: {
                              attendee_email: values.email,
                              attendee_first: values.firstName,
                              attendee_id: resp['attendee_id'],
                              attendee_role: resp['role'],
                              attendee_last: values.lastName,
                              client_id: infoData['hostModel']['clientId'],
                              stream_id: props.roomId,
                              stream_instance_id: resp['stream_instance_id'],
                              user_id: infoData['hostModel']['userId'],
                              max_presenters: 3,
                              elapsed_seconds: '0',
                              date: new Date().toUTCString(),
                            },
                            event_type: 'attendee_joined',
                          },
                        ]);
                      }
                    } catch (error) {
                      callEvent([
                        {
                          event_data: {
                            attendee_email: values.email,
                            attendee_first: values.firstName,
                            attendee_id: resp['attendee_id'],
                            attendee_role: resp['role'],
                            attendee_last: values.lastName,
                            client_id: 'repsites',
                            stream_id: props.roomId,
                            stream_instance_id: resp['stream_instance_id'],
                            user_id: 'marketamer-943788',
                            max_presenters: 3,
                            elapsed_seconds: '0',
                            date: new Date().toUTCString(),
                          },
                          event_type: 'attendee_joined',
                        },
                      ]);
                      // console.log(error);
                    }

                    var payload = {
                      referred_by_livestream_instance_id:
                        info['streamInstanceId'],
                      third_party_id: resp['attendee_id'],
                      live_attendee_id: resp['attendee_id'],
                      email: values.email,
                      last_name: values.lastName,
                      first_name: values.firstName,
                      source: 'live',
                      folder: 'live',
                      host_name: props.hostData.host_full_name,
                      host_uuid: props.hostData.host_id,
                    };

                    var re = response.issuer_metadata;

                    const url = re?.webhook_domain
                      ? `${re?.webhook_domain}/remote/contacts/add.json`
                      : re?.webhook_endpoint_join;

                    try {
                      callAddContact(
                        payload,
                        url,
                        `Bearer ${re?.webhook_token}`
                      );
                    } catch (error) {
                      // console.log(error);
                    }

                    callAttendeeToken(props.roomId, {
                      stream_instance_id: resp['stream_instance_id'],
                      stream_vendor_user_id: resp['stream_vendor_user_id'],
                    }).then((tokenResponse: any) => {
                      dispatch(setAttendeeToken(tokenResponse));
                      setIsShowLoader(false);
                      props.attendeeJoinedCallback();
                    });
                  })
                  .catch(() => {
                    props.setWaittingCallback(true);
                    if (timer != null) {
                      clearInterval(timer);
                    }
                    timer = setInterval(
                      () =>
                        tryToJoin(
                          values.email,
                          values.lastName,
                          values.firstName
                        ),
                      5000
                    );

                    setIsShowLoader(false);
                  });
              })
              .catch((err) => {
                if (
                  err?.response?.data?.error?.indexOf('is not ready to join') >
                  -1
                ) {
                  props.setWaittingCallback(true);
                  tryToJoin(values.email, values.lastName, values.firstName);
                }
                setIsShowLoader(false);
              });
          });
        }}
        validationSchema={registrationSchema}
      >
        {({ errors, handleChange, handleSubmit, touched }) => (
          <>
            {/* {console.log(errors)} */}
            <div className='w-full px-4 sm:px-12'>
              <FloatingTextInput
                inputProps={{
                  name: 'firstName',
                  onChange: handleChange('firstName'),
                }}
                containerClass='mt-4 sm:mt-6'
                label={language['first_name_field']}
                showError={touched.firstName}
                error={errors.firstName}
              />
              <FloatingTextInput
                inputProps={{
                  name: 'lastName',
                  onChange: handleChange('lastName'),
                }}
                containerClass='mt-4 sm:mt-6'
                label={language['last_name_field']}
                showError={touched.lastName}
                error={errors.lastName}
              />
              <FloatingTextInput
                inputProps={{
                  name: 'email',
                  onChange: handleChange('email'),
                }}
                containerClass='mt-4 sm:mt-6'
                label={language['email_field']}
                showError={touched.email}
                error={errors.email}
              />
            </div>

            <div className='w-full px-4 sm:px-12'>
              <SubmitButton
                bgColor={registrationBrandColor}
                childrenClass='my-1 justify-center w-full'
                buttonClass='mt-4 sm:mt-8 w-full !flex justify-center'
                padding={1}
                onPress={() => {
                  handleSubmit();
                }}
              >
                <span
                  className='text-lg font-medium'
                  style={{ color: client === 'partner.co' ? '#000000' : undefined }}
                >
                  {language['join_button']}
                </span>
              </SubmitButton>
            </div>

            {client !== 'partner.co' && (
            <div className='flex justify-center mt-4 sm:mt-8'>
              <select
                className='bg-transparent text-white border border-gray-400 rounded px-4 py-2'
                value={selectedLanguage}
                onChange={handleLanguageChange}
                style={{ color: registrationBrandColor }}
              >
                <option value='1' disabled>
                  Please select language
                </option>
                <option value='en'>English (English)</option>
                <option value='zh_CN'>中文 (Chinese)</option>
                <option value='id'>Bahasa Indonesia (Indonesian)</option>
                <option value='ms_MY'>Bahasa Melayu (Malay)</option>
              </select>
            </div>
            )}
          </>
        )}
      </Formik>
      <Loader
        message={language['joining_stream_wait']}
        isShowLoader={isShowLoader}
      ></Loader>
    </>
  );
};

export default RegistrationForm;
